export default __webpack_public_path__ + "static/media/august2024-5.a45a7363.jpg";